import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { ConfigService } from '@tsin-core/services/common/config.service';
import { loadRuntimeConfig } from '@tsin-core/config/config.loader';
import { provideRouter, withComponentInputBinding, withDebugTracing } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    LOCAL_STORAGE_ENGINE,
    NgxsStoragePluginModule,
    SESSION_STORAGE_ENGINE,
    StorageOption,
    withNgxsStoragePlugin
} from '@ngxs/storage-plugin';
import { routes } from './app.routes';
import { NgxsModule, provideStore } from '@ngxs/store';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { jwtInterceptor } from '@tsin-core/interceptors/jwt.interceptor';
import { loggingInterceptor } from '@tsin-core/interceptors/logging.interceptor';
import { AuthState } from '@tsin-core/states/auth.state';
import { UserState } from '@tsin-core/states/user.state';
import { environment } from '@tsin-env/environment';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { JobOpeningState } from '@tsin-core/states/job-opening/job-opening.state';
import { JobDescriptionState } from '@tsin-core/states/job-description/job-description.state';
import { ApplicationState } from '@tsin-core/states/applications/application.state';
import { StaffState } from '@tsin-core/states/staff/staff.state';
import { DepartmentStore } from '@tsin-core/states/departments/department.store';
import { RequestsStore } from '@tsin-core/states/request-forms/requests.store';
import { ConferenceRequestsStore } from '@tsin-core/states/request-forms/conference/requests.store';
import { ReimbursementStore } from '@tsin-core/states/request-forms/reimbursement/requests.store';
import { TimeOffStore } from '@tsin-core/states/request-forms/time-off/time-off.store';
import { TravelRequestsStore } from '@tsin-core/states/request-forms/travel/requests.store';
import { ChangeRequestsState } from '@tsin-core/states/request-forms/change-request/store';
import { OverTimeStore } from '@tsin-core/states/request-forms/over-time/requests.store';
import { TimeSheetState } from '@tsin-core/states/timesheet/timesheet.state';
import { PerformanceManagementStore } from '@tsin-core/states/request-forms/performance/state';
import { EnrolementStore } from '@tsin-core/states/enrolement/enrole.state';
import { UserPreferencesState } from '@tsin-core/states/user-preferences/user-preferences.state';

export const appConfig: ApplicationConfig = {
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: loadRuntimeConfig,
            deps: [ConfigService],
            multi: true,
        },
        MessageService,
        // provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes, withComponentInputBinding(), withDebugTracing()),
        importProvidersFrom(BrowserAnimationsModule, ToastModule),
        provideHttpClient(withInterceptors([jwtInterceptor, loggingInterceptor])),
        // AppStoreModule)
        provideStore(
            [
                AuthState,
                UserState,
                JobOpeningState,
                JobDescriptionState,
                ApplicationState,
                StaffState,
                DepartmentStore,
                RequestsStore,
                ConferenceRequestsStore,
                ReimbursementStore,
                TimeOffStore,
                TravelRequestsStore,
                ChangeRequestsState,
                OverTimeStore,
                TimeSheetState,
                PerformanceManagementStore,
                EnrolementStore,
                UserPreferencesState
            ],
            withNgxsStoragePlugin({
                keys: [
                    {
                        key: 'userState.users',
                        engine: LOCAL_STORAGE_ENGINE
                    },
                    {
                        key: 'staffState.accountCompletion',
                        engine: LOCAL_STORAGE_ENGINE
                    },
                    {
                        key: 'staffState.userWithCode',
                        engine: LOCAL_STORAGE_ENGINE
                    },
                    {
                        key: 'staffState.staffRole',
                        engine: LOCAL_STORAGE_ENGINE
                    },
                    {
                        key: 'jobOpening.SelectedJobOpening',
                        engine: LOCAL_STORAGE_ENGINE
                    },
                    {
                        key: 'authState.auth',
                        engine: LOCAL_STORAGE_ENGINE
                    },
                    {
                        key: 'application.userApplication',
                        engine: LOCAL_STORAGE_ENGINE
                    },
                    {
                        key: 'application.references',
                        engine: LOCAL_STORAGE_ENGINE
                    },
                    {
                        key: 'application.isPreview',
                        engine: LOCAL_STORAGE_ENGINE
                    }
                ]
            })
        ),
        importProvidersFrom(
            // NgxsModule.forRoot([AuthState, UserState, JobOpeningState, JobDescriptionState], {
            //   developmentMode: !environment.production,
            // }),
            // NgxsStoragePluginModule.forRoot({ keys: ['authState.auth'] }),
            NgxsLoggerPluginModule.forRoot({
                disabled: environment.production
            }),
            NgxsReduxDevtoolsPluginModule.forRoot({
                disabled: environment.production
            })
        )
    ]
};
